module.exports = __webpack_public_path__ + "static/frontUserNew/img/logo-header.677661f2.png";